import type { ReactNode } from 'react'

import { Navigation } from './Navigation.js'
import styles from './AppShell.module.css'

/**
 * The navigation and the space it needs, without the shell's behaviour.
 *
 * One definition of the frame, used by `AppShell` for every ordinary screen and
 * by the log flow for the one state where it has nothing to protect. The
 * layout lives here rather than being written twice: `.main`'s bottom padding is
 * what keeps the last row of every list clear of the fixed bar and the iOS home
 * indicator, and a second copy of that number is a second copy to get wrong.
 */
export function NavigationFrame({ children }: { readonly children: ReactNode }) {
  return (
    <div className={styles['shell']}>
      <Navigation />
      <main className={styles['main']}>{children}</main>
    </div>
  )
}
